import { Box, Flex } from '@grupoboticario/flora-react'
import {
  Carousel,
  CarouselContent,
  NextButton,
  PreviousButton,
} from '@grupoboticario/flora-team-react-carousel'

import { positionButtonOverrideStyles } from './Styles'
import { CarouselShopProps, ITEM_LIST_NAME_MAP } from './types'
import { ShopWindowProductCard } from './ShopWindowProductCard/ShopWindowProductCard'
import { useEffect } from 'react'
import { sendViewItemListEvent, trackShopWindowGAEvents } from 'src/service/trackShopWindowGAEvents'
import { useSwipeable } from 'react-swipeable'

export const CarouselShop = ({
  products,
  slidesToShow,
  shopWidth,
  shopWindowType,
  isMobile,
}: CarouselShopProps) => {
  const handleSwipeLeft = () => {
    trackShopWindowGAEvents({
      cd_interaction_detail: 'swipe:proximo',
      cd_section: shopWindowType,
    })
  }

  const handleSwipeRight = () => {
    trackShopWindowGAEvents({
      cd_interaction_detail: 'swipe:anterior',
      cd_section: shopWindowType,
    })
  }

  const handlePreviousButtonClick = () =>
    trackShopWindowGAEvents({
      cd_interaction_detail: 'click:anterior',
      cd_section: shopWindowType,
    })

  const handleNextButtonClick = () =>
    trackShopWindowGAEvents({
      cd_interaction_detail: 'click:proximo',
      cd_section: shopWindowType,
    })

  const swipeHandlers = useSwipeable({
    onSwipedLeft: handleSwipeLeft,
    onSwipedRight: handleSwipeRight,
  })

  useEffect(() => {
    if (products?.length) {
      const listName = ITEM_LIST_NAME_MAP[shopWindowType]
      if (listName) {
        sendViewItemListEvent({ listName, products })
      }
    }
  }, [products, shopWindowType])

  return (
    <Box
      css={{
        width: shopWidth,
        maxWidth: 'calc(100vw - 40px)',
        '@fullscreen': { maxWidth: 'calc(1200px - 2rem)' },
      }}
    >
      <Carousel
        variant={isMobile ? 'fluid' : 'container'}
        role="region"
        aria-labelledby="carousel-heading"
        data-testid="carousel"
        css={{
          ...(isMobile ? positionButtonOverrideStyles : {}),
        }}
      >
        <PreviousButton
          aria-controls="carousel"
          aria-label="Ver o produto anterior"
          onClick={handlePreviousButtonClick}
        />
        <CarouselContent
          role="list"
          slidesToShow={slidesToShow}
          infinite={false}
          {...swipeHandlers}
        >
          {products.map((product, index) => (
            <Flex
              key={product.sku}
              css={{
                padding: '0 2px',
                height: '337px',
              }}
              role="group"
              aria-labelledby={`product-${product.sku}-heading`}
              aria-hidden="false"
            >
              <ShopWindowProductCard
                product={product as any}
                index={index}
                shopWindowType={shopWindowType}
              />
            </Flex>
          ))}
        </CarouselContent>

        <NextButton
          aria-controls="carousel"
          aria-label="Ver o próximo produto"
          onClick={handleNextButtonClick}
        />
      </Carousel>
    </Box>
  )
}
